import React, { useEffect } from 'react'
import styles from './LayoutSetting.module.scss'
import MasterLayout from 'layouts/MasterLayout/MasterLayout'
import { LayoutProps } from 'models/common'
import { useLocation, useNavigate } from 'react-router-dom'

const LayoutSetting = (props: LayoutProps) => {
  const location = useLocation()
  const navigate = useNavigate()
  useEffect(() => {
    if (!location?.state?.appId) {
      navigate(-1)
    }
  }, [])
  return (
    <MasterLayout>
      <p className={styles.title}>{location?.state?.funcName}</p>
      <p className={styles.title}>{location?.state?.appName}</p>
      <section>{props.children}</section>
    </MasterLayout>
  )
}

export default LayoutSetting
